import { UserProfile } from '@/entities/user-profile';

export const getUserName = (userProfile: UserProfile | null): string | null => {
	if (!userProfile) return null;
	if (userProfile.FullName) return userProfile.FullName;
	if (userProfile.FirstName && userProfile.LastName) {
		return `${userProfile.FirstName} ${userProfile.LastName}`;
	}
	return null;
};
